import { FunctionComponent } from "react";
import { useStepScope } from "../stepped-flow-step-scope";
import type { IProps } from "./stepped-flow-formik-step.types";

/**
 * Declares one step of a SteppedModal.Formik or SteppedDrawer.Formik. The shell renders every step so each
 * can declare its rules, but only the active step renders its children — inactive steps cost nothing. `label`,
 * `nextButtonText` and `validation` are read from this element by the shell rather than used here.
 */
const SteppedFlowFormikStep: FunctionComponent<IProps> = ({ children }) => {
    const { isActive } = useStepScope();
    return isActive ? <>{children}</> : null;
};

export { SteppedFlowFormikStep };
